class Invitation {
  constructor(data = {}) {
    this.id = data.id || null;
    this.email = data.email || '';
    this.registered = data.registered || false;
    this.created = new Date(data.created).toLocaleDateString() || "";
  }
}

export { Invitation };